import {BaseModal, ModalBody, ModalFooter, ModalHeader, ModalHeaderTitle, ModalSize} from "./StandardModal";
import React, { useMemo } from "react";
import {StepProvider} from "../Stepper/StepContext";
import {StepBody, StepFooter, StepHeader, StepHeaderType} from "../Stepper/Step";
import Spinner from "../Spinner/Spinner";

/**
 * StepperModal
 *
 * Props:
 * @param {function} onClose - Function to call when modal is closed.
 * @param {string} title - Modal title./**
 * @param {string} modalSize - Modal width based on design specs.
 * @param {boolean} isLoading - Show/hide loading spinner.
 * @param {boolean} isStepLoading - Show/hide loading spinner for step content.
 * @param {number} stepHeaderType - Type of step header to render, defaults to StepHeaderType.STANDARD.
 * @param {React.ReactNode} children - Modal content, should include ModalHeader, ModalBody, StepButtons, and ModalFooter.
 */
export const StepperModal = ({ onClose, title, modalSize, isLoading, isStepLoading, stepHeaderType = StepHeaderType.HORIZONTAL, children }) => {
    const childrenArray = useMemo(() => React.Children.toArray(children), [children]);
    
    return <BaseModal title={title} size={modalSize ?? ModalSize.X_LARGE} isLoading={isLoading}>
        <ModalHeader onclose={onClose}>
            <ModalHeaderTitle>{title}</ModalHeaderTitle>
        </ModalHeader>
        <StepProvider steps={childrenArray}>
            <ModalStepContainer stepHeaderType={stepHeaderType} isStepLoading={isStepLoading}/>
        </StepProvider>
    </BaseModal>
};

const ModalStepContainer = ({stepHeaderType,  isStepLoading }) => {
    return <>
        <ModalBody>
            {stepHeaderType !== StepHeaderType.NONE && <StepHeader type={stepHeaderType}/>}
            {isStepLoading ? <Spinner />: <StepBody />}
        </ModalBody>
        <ModalFooter>
            {!isStepLoading && <StepFooter/>}
        </ModalFooter></>
}

